import { Mark } from '@mui/base'
import { Slider as MuiSlider, styled } from '@mui/material'

export const StyledSlider = styled(MuiSlider)(({ theme }) => ({
  '&.MuiSlider-root': {
    width: '100%',
    margin: '30px 11px auto',
    paddingBottom: 0,
  },
  '& .MuiSlider-mark': {
    width: '4px',
    height: '4px',
    borderRadius: '100%',
    backgroundColor: theme.palette.white,
    border: `1px solid ${theme.palette.gray}`,
    opacity: 1,
  },
  '& .MuiSlider-markActive': {
    width: '6px',
    height: '6px',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '100%',
    border: '1px solid #fff',
  },
  '& .MuiSlider-rail': {
    backgroundColor: theme.palette.gray,
  },
  '&.MuiSlider-rail': {
    height: '1px',
  },
  '& .MuiSlider-thumb': {
    width: '13px',
    height: '13px',
    transform: 'translate(-10%, -50%)',
    boxShadow: 'none',
    border: '1px solid #fff',
  },
  '& .MuiSlider-markLabel': {
    color: theme.palette.gray,
    top: 'auto',
    bottom: '25px',
    ...theme.typography.caption1,
    transform: 'translateX(-25%)',
    maxWidth: '50px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}))

interface Props {
  marks: Mark[]
  step?: number
  size: 'small' | 'medium'
  color: 'primary' | 'secondary'
  value: number | number[]
  onChange: (value: number) => void
}

export function Slider({ marks, step, size, color, value, onChange }: Props) {
  return (
    <StyledSlider
      step={step}
      size={size}
      max={marks.length - 1}
      marks={marks}
      color={color}
      sx={{
        '.MuiSlider-markLabel[data-index="0"]': {
          transform: 'translate(0)',
        },
        [`.MuiSlider-markLabel[data-index="${marks.length - 1}"]`]: {
          transform: 'translate(-80%)',
        },
      }}
      value={value}
      onChange={(_, value) => onChange(value as number)}
    />
  )
}
